import { add, sub } from "date-fns";

// Function cookies handler.
export const getCookie = (name) => {
  let cookie = {};
  document.cookie.split(';').forEach(function(el) {
    let [k,v] = el.split('=');
    cookie[k.trim()] = v;
  })
  return cookie[name];
};

export function clearCookies(names) {
  if (names?.length > 0) {
    for(let name of names) {
      setCookie(name, '', { 'max-age': -1 })
    }
  } else {
    setCookie(names, '', { 'max-age': -1 })
  }

  return;
}

export function setCookie(name, value, options = {}) {
  options = {
    path: '/',
    // add other defaults here if necessary
    ...options
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
  return;
}

